import { FC } from "react";
import { appointment } from "../../../../types/calendar";
import { getWeekDay } from "../../../../utils/DateUtils";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

interface ReservationDetailsProps {
  appointment: appointment & { cancel_reason?: string };
}
const infoSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 2.00003C6.81332 2.00003 5.65328 2.35192 4.66658 3.01121C3.67989 3.6705 2.91085 4.60757 2.45673 5.70393C2.0026 6.80029 1.88378 8.00669 2.11529 9.17057C2.3468 10.3345 2.91825 11.4036 3.75736 12.2427C4.59648 13.0818 5.66558 13.6532 6.82946 13.8847C7.99335 14.1163 9.19975 13.9974 10.2961 13.5433C11.3925 13.0892 12.3295 12.3201 12.9888 11.3335C13.6481 10.3468 14 9.18672 14 8.00003C14 6.40873 13.3679 4.88261 12.2426 3.75739C11.1174 2.63217 9.5913 2.00003 8 2.00003ZM8 13C7.0111 13 6.0444 12.7068 5.22215 12.1574C4.39991 11.608 3.75904 10.8271 3.38061 9.91345C3.00217 8.99982 2.90315 7.99448 3.09608 7.02458C3.289 6.05467 3.76521 5.16376 4.46447 4.4645C5.16373 3.76523 6.05465 3.28903 7.02455 3.0961C7.99446 2.90318 8.99979 3.00219 9.91342 3.38063C10.8271 3.75907 11.6079 4.39993 12.1574 5.22218C12.7068 6.04443 13 7.01112 13 8.00003C13 9.32611 12.4732 10.5979 11.5355 11.5356C10.5979 12.4732 9.32609 13 8 13Z"
      fill="#00086D"
    />
    <path
      d="M8.00024 6.85003C7.86763 6.85003 7.74045 6.90271 7.64668 6.99647C7.55292 7.09024 7.50024 7.21742 7.50024 7.35003V10.75C7.50024 10.8826 7.55292 11.0098 7.64668 11.1036C7.74045 11.1974 7.86763 11.25 8.00024 11.25C8.13285 11.25 8.26002 11.1974 8.35379 11.1036C8.44756 11.0098 8.50024 10.8826 8.50024 10.75V7.35003C8.50024 7.21742 8.44756 7.09024 8.35379 6.99647C8.26002 6.90271 8.13285 6.85003 8.00024 6.85003ZM8.00024 4.80003C7.86488 4.80512 7.73661 4.86184 7.64176 4.95854C7.54692 5.05525 7.4927 5.1846 7.49024 5.32003V5.40003C7.49 5.46526 7.50335 5.52984 7.52943 5.58963C7.55551 5.64943 7.59375 5.70314 7.64172 5.74735C7.6897 5.79156 7.74635 5.8253 7.80807 5.84642C7.86979 5.86754 7.93524 5.87558 8.00024 5.87003C8.13127 5.86508 8.25559 5.81081 8.3483 5.71809C8.44102 5.62538 8.49529 5.50106 8.50024 5.37003V5.25003C8.50063 5.18648 8.48756 5.12357 8.46189 5.06544C8.43621 5.00731 8.39852 4.95527 8.35128 4.91276C8.30404 4.87025 8.24834 4.83822 8.18783 4.81879C8.12733 4.79936 8.06339 4.79297 8.00024 4.80003Z"
      fill="#00086D"
    />
  </svg>
);
const clockSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 10 10"
    fill="none"
  >
    <g clip-path="url(#clip0_1096_5813)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.00067 0.415863C2.47404 0.415863 0.414062 2.47292 0.414062 4.99914C0.414062 7.52536 2.47445 9.58491 5.00067 9.58491C7.52689 9.58491 9.58311 7.52536 9.58311 4.99914C9.58311 2.47292 7.52689 0.415863 5.00067 0.415863ZM5.00067 1.24919C5.49331 1.24836 5.98127 1.3448 6.43656 1.53297C6.89185 1.72114 7.30552 1.99735 7.65383 2.34574C8.00214 2.69413 8.27825 3.10785 8.46632 3.56318C8.65439 4.01852 8.75072 4.5065 8.74979 4.99914C8.75078 5.49191 8.6545 5.98004 8.46648 6.43554C8.27846 6.89103 8.00239 7.30494 7.6541 7.65355C7.30581 8.00215 6.89215 8.27858 6.43682 8.46701C5.98149 8.65543 5.49345 8.75214 5.00067 8.75159C4.50768 8.75219 4.01942 8.65555 3.56383 8.4672C3.10824 8.27884 2.69428 8.00248 2.34565 7.65392C1.99701 7.30536 1.72055 6.89146 1.5321 6.43592C1.34364 5.98037 1.24689 5.49213 1.24739 4.99914C1.24739 2.92333 2.92486 1.24919 5.00067 1.24919ZM4.994 2.07668C4.93893 2.07722 4.88451 2.08867 4.83389 2.11037C4.78327 2.13208 4.73746 2.1636 4.6991 2.20312C4.66074 2.24264 4.6306 2.28938 4.61041 2.34062C4.59023 2.39187 4.58041 2.4466 4.58151 2.50167V4.99914C4.58174 5.05397 4.59279 5.10821 4.61403 5.15876C4.63526 5.20931 4.66626 5.25517 4.70526 5.29372L6.3719 6.9612C6.41046 7.00087 6.45652 7.03247 6.50741 7.05415C6.55831 7.07583 6.61301 7.08716 6.66832 7.08748C6.72364 7.08779 6.77847 7.07709 6.8296 7.056C6.88074 7.0349 6.92717 7.00384 6.96617 6.96461C7.00518 6.92538 7.03598 6.87878 7.05679 6.82753C7.07759 6.77627 7.08798 6.72139 7.08735 6.66607C7.08672 6.61076 7.07508 6.55612 7.05311 6.50535C7.03114 6.45458 6.99929 6.4087 6.9594 6.37037L5.41567 4.82664V2.50167C5.41679 2.44583 5.40667 2.39034 5.38592 2.33849C5.36517 2.28664 5.33421 2.23949 5.29487 2.19984C5.25554 2.1602 5.20863 2.12886 5.15695 2.10771C5.10526 2.08655 5.04985 2.07599 4.994 2.07668Z"
        fill="#9999A7"
      />
    </g>
    <defs>
      <clipPath id="clip0_1096_5813">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ReservationDetails: FC<ReservationDetailsProps> = ({ appointment }) => {
  const intl = useIntl();
  const { currentLang } = useSelector(
    (state: { user: { currentLang: "en" | "ar" } }) => state.user
  );
  return (
    <div className="my-2 space-y-2">
      <p className="text-lg space-x-1">
        <span>{infoSVG}</span>
        <span>
          {" "}
          {intl.formatMessage({
            id: "aboutReservation",
            defaultMessage: "عن الحجز",
          })}
        </span>
      </p>
      <div className="space-y-1">
        {/* <div className="flex gap-2 justify-between">
          <p className="  flex gap-1 items-center text-gray-600 ">
            <span className="mx-px">{clockSVG}</span>
            <span>
              {intl.formatMessage({
                id: "bookedDate",
                defaultMessage: "تم الحجز يوم",
              })}
              ,
            </span>
            <span>
              {getWeekDay(new Date(appointment?.created_at), currentLang)}{" "}
              {new Date(appointment?.created_at).toLocaleString(
                currentLang === "ar" ? "ar" : "en",
                {
                  hour12: true,
                }
              )}
            </span>
          </p>
          {/* <p className="flex gap-1 items-center  text-gray-600 ">
            <span>{profileSVG}</span>
            <span>
              {intl.formatMessage({
                id: "reservationBy",
                defaultMessage: "تم الحجز بواسطة",
              })}{" "}
              ,
            </span>
            <span>{"Jhon Doe"}</span>
          </p> */}
      </div>
      <div className="flex gap-2 justify-between">
        <p className=" flex gap-1 items-center text-gray-600 ">
          <span className="mx-px">{clockSVG}</span>
          <span>
            {intl.formatMessage({
              id: "updatedDate",
              defaultMessage: "تم التحديث يوم ",
            })}{" "}
            ,
          </span>
          <span>
            {getWeekDay(new Date(appointment?.created_at), currentLang)}{" "}
            {new Date(appointment?.updated_at).toLocaleString(
              currentLang === "ar" ? "ar" : "en",
              {
                hour12: true,
              }
            )}{" "}
          </span>
        </p>
        {/* <p className="flex gap-1 items-center text-gray-600 ">
            <span>{profileSVG}</span>
            <span>
              {intl.formatMessage({
                id: "updatedBy",
                defaultMessage: "تم التحديث بواسطة",
              })}
              ,
            </span>
            <span>{"Jhon Doe"}</span>
          </p>
        </div> */}
        {appointment?.status === "canceled" ? (
          <div className="flex gap-2 justify-between">
            <p className="flex gap-1 items-center text-gray-600 ">
              <span className="mx-px">{clockSVG}</span>

              <span className=" text-gray-500 ">
                {intl.formatMessage({
                  id: "cancelReason",
                  defaultMessage: "سبب الالغاء",
                })}{" "}
              </span>
            </p>
            <p className="flex gap-1 items-center  text-gray-600 ">
              <span>
                {appointment?.cancellation_reason?.name || "static reason"}
              </span>
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ReservationDetails;
